import React from 'react';
import { render } from 'react-dom';
import { RootStoreProvider } from './mobx-store/root-store';
import AppRouter from './pages/app-router';

const renderApp = () => {
  render(
    <RootStoreProvider>
      <AppRouter />
    </RootStoreProvider>,
    document.getElementById('root')
  );
};

export default renderApp;
